import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonComponentsModule } from 'src/app/common-components/common-components.module';
import { FormElementsModule } from 'src/app/form-elements/form-elements.module'; 
import { CustomAddressSearchComponent } from './custom-address-search.component';

@NgModule({
  declarations: [
    CustomAddressSearchComponent,
    
    
    
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CommonComponentsModule ,
    FormElementsModule  ],
  exports: [
    CustomAddressSearchComponent,
    CommonComponentsModule
    
  ]
})
export class CustomAddressSearchModule { }
